import byIdMaker from 'reducersMakers/byIdMaker';
import * as actions from 'actions';

export default byIdMaker({
  fetchSuccessTypes: [actions.MAIL_THREADS_FETCH_SUCCESS],
  entityType: 'threads'
});



/** WEBPACK FOOTER **
 ** ./src/members/state/mail/mailThreads/byId/reducer.js
 **/